import { Autocomplete, FormControl, TextField } from '@mui/material';

import type { NodeItem } from '@models/flows';
import { useAllPaymentsErrorCodesStore } from '@features/paymentErrorCodes/store';
import { normalizeErrorsForNode } from '@utils/flows';

type ErrorNodeConfigProps = {
  currentNode: NodeItem;
  onChange: (data: NodeItem) => void;
};

function ErrorNodeConfiguration({ currentNode, onChange }: ErrorNodeConfigProps) {
  const errorStore = useAllPaymentsErrorCodesStore();
  const errorOptions = normalizeErrorsForNode(errorStore);
  const currentErrorOption =
    errorOptions.find((option) => option.id === currentNode.errorId) || null;

  if (!currentNode) return null;

  const handleChange = (event: NodeItem | null) => {
    if (!event) return;

    const selectedOption = errorOptions.find((option) => option.id === event.id);

    if (!selectedOption) return;

    onChange({
      errorId: selectedOption.id,
      label: selectedOption.label,
      id: currentNode.id,
    });
  };

  return (
    <FormControl fullWidth>
      <Autocomplete
        disablePortal
        options={errorOptions}
        value={currentErrorOption}
        renderInput={(params) => <TextField {...params} id={params.id} label="Error codes..." />}
        sx={{ width: 300 }}
        slotProps={{
          popper: {
            style: { zIndex: 2000 },
          },
        }}
        onChange={(_, value) => {
          handleChange(value);
        }}
      />
    </FormControl>
  );
}

export default ErrorNodeConfiguration;
